import { gql } from '@apollo/client';

export default gql`
  mutation subscriptionPurchased ($transactionId: String!) {
      subscriptionPurchased (transactionId: $transactionId)
  }
`;